module.exports = __webpack_public_path__ + "images/emoji/sleepy.2a903da980fbfaae727b.png";